var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicketStateStornoIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon ticket-state-storno-icon",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 13,
    fill: "#aab2bd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 4.235a7.765 7.765 0 110 15.53 7.765 7.765 0 010-15.53zM5.647 12a6.353 6.353 0 0010.318 4.964l-8.928-8.93A6.326 6.326 0 005.647 12zM12 5.647c-1.5 0-2.879.52-3.966 1.39l8.93 8.928A6.353 6.353 0 0012 5.647z"
  }))));
}

export default SvgTicketStateStornoIconSv;